import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Avatar,
  Typography,
  Button,
  Box,
  Divider,
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HomeIcon from "@mui/icons-material/Home";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { useState } from "react";
import { useEffect } from "react";
import FormRecibo from "../reciboContado/FormRecibo";
import DialogConfirmarRecibo from "./dialogs/DialogConfirmarRecibo";
import * as api from "./api";
import { useToast } from "../../../Hooks/UseToast";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

const DialogoFinalizacion = (props) => {
  console.log("Props: ", props);
  const [comprEmitido, setComprEmitido] = useState(null);
  // Si el recibo es obligatorio (contado) se muestra el form directo y sin salida.
  // Si no, primero preguntamos si quiere cargar el recibo ahora.
  const esReciboObligatorio = Boolean(props.cargaRecibo);
  const [mostrarFormRecibo, setMostrarFormRecibo] = useState(esReciboObligatorio);
  const [preguntarRecibo, setPreguntarRecibo] = useState(!esReciboObligatorio);
  const { Toast, showToast } = useToast();

  useEffect(() => {
    api.getComprobanteEmitido(props.facturaId, setComprEmitido);
  }, []);

  const handleClose = () => {
    if (!props.cargaRecibo) {
      props.handleCloseAll();
    }
  };

  const gridSize =
    props.maxWidth == "sm"
      ? { icono: 2, titulo: 10 }
      : { icono: 1, titulo: 11 };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth={props.maxWidth}
        fullWidth
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)",
            height: 8,
          }}
        />
        <DialogContent sx={{ py: 1, px: 2 }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid item xs={gridSize.icono}>
              <Box
                display="flex"
                justifyContent={{ xs: "center", sm: "flex-start" }}
              >
                <Avatar
                  sx={{
                    bgcolor: "#E8F5E9",
                    width: 70,
                    height: 70,
                    boxShadow: "0 4px 14px rgba(76, 175, 80, 0.3)",
                  }}
                >
                  {props.icon || (
                    <CheckCircleIcon sx={{ fontSize: 48, color: "#4CAF50" }} />
                  )}
                </Avatar>
              </Box>
            </Grid>
            <Grid item xs={gridSize.titulo}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Stack spacing={1}>
                  <Typography variant="h6" color="#1B5E20" fontWeight="700">
                    {props.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {props.subtitle}
                  </Typography>
                  {props.confirmText && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1, fontStyle: "italic" }}
                    >
                      {props.confirmText}
                    </Typography>
                  )}
                </Stack>
                {comprEmitido?.importe_total !== undefined &&
                  props?.cargaRecibo && (
                    <Box
                      sx={{
                        bgcolor: "#E8F5E9",
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        border: "1px solid #A5D6A7",
                        boxShadow: "0 2px 8px rgba(76, 175, 80, 0.15)",
                        minWidth: 140,
                        textAlign: "right",
                      }}
                    >
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mb: 0.5 }}
                      >
                        Saldo:
                      </Typography>
                      <Typography variant="h6" color="#1B5E20" fontWeight="700">
                        $
                        {comprEmitido?.importe_total?.toLocaleString("es-AR", {
                          minimumFractionDigits: 2,
                        })}
                      </Typography>
                    </Box>
                  )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              {preguntarRecibo && (
                <DialogConfirmarRecibo
                  open={preguntarRecibo}
                  onSi={() => {
                    setPreguntarRecibo(false);
                    setMostrarFormRecibo(true);
                  }}
                  onNo={() => {
                    setPreguntarRecibo(false);
                    setMostrarFormRecibo(false);
                  }}
                />
              )}
              {mostrarFormRecibo && (
                <FormRecibo
                  recObligatorio={props.cargaRecibo}
                  clienteData={props.cliente}
                  comprEmitido={comprEmitido}
                  handleCloseAll={props.handleCloseAll}
                  setCargaRecibo={setMostrarFormRecibo}
                  showToast={showToast}
                />
              )}
              {/* <Grid
                py={2}
                spacing={1}
                container
                direction="row"
                alignItems="center"
                mt={1}
              >
                <Grid item xs={6} md={6} lg={6}>
                  <Button
                    // disabled={disBtns}
                    variant="contained"
                    color="success"
                    fullWidth
                    startIcon={<ReceiptLongIcon />}
                    onClick={props.onVerComprobante}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      px: 3,
                    }}
                  >
                    Ver Comprobante
                  </Button>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Button
                    disabled={props.disIrCtaCte}
                    fullWidth
                    variant="outlined"
                    color="primary"
                    startIcon={<AccountBalanceWalletIcon />}
                    onClick={props.onCuentaCorriente}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      px: 3,
                    }}
                  >
                    Ver Cuenta Corriente
                  </Button>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        {!mostrarFormRecibo && !preguntarRecibo && (
          <DialogActions
            sx={{
              p: 2.5,
              gap: 1,
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <Button
              // disabled={disBtns}
              variant="outlined"
              color="inherit"
              startIcon={<ReceiptIcon color="primary" />}
              onClick={props.onLimpiarPantalla}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                color: "#616161",
                borderColor: "#BDBDBD",
              }}
            >
              Hacer otra factura
            </Button>

            <Button
              // disabled={disBtns}
              variant="outlined"
              color="inherit"
              startIcon={<HomeIcon />}
              onClick={props.onIrAlInicio}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                color: "#616161",
                borderColor: "#BDBDBD",
              }}
            >
              Ir al Inicio
            </Button>
          </DialogActions>
        )}
      </Dialog>
      {Toast}
    </div>
  );
};

export default DialogoFinalizacion;
